import { Reference } from '@approvalmax/types';
import { domain } from 'modules/data';
import {
    NetSuiteExpenseCategory,
    NetSuiteItem,
    NetSuiteSalesTaxItem,
} from 'pages/requestForm/data/netsuite/NetSuiteContext';

import { RequestFormLineExtender } from '../../data/types';
import { CustomFieldUpdateHandler } from '../useUpdateLineCustomField/useUpdateLineCustomField.types';

export enum GroupEditItemsField {
    Item = 'item',
    Category = 'category',
    Account = 'account',
    TaxAccount = 'taxAccount',
    ExpenseAccount = 'expenseAccount',
    Currency = 'currency',
    TaxCode = 'taxCode',
    Class = 'class',
    Department = 'department',
    Location = 'location',
    Customer = 'customer',
    AmortizationSchedule = 'amortizationSchedule',
}

export type GenericNetSuiteListItem = RequestFormLineExtender &
    Partial<{
        checked: boolean;
        account: Reference | null;
        taxCode: Reference | null;
        class: Reference | null;
        department: Reference | null;
        location: Reference | null;
    }>;

export interface FieldUpdateHandler {
    <K extends keyof GenericNetSuiteListItem>(id: string, key: string, value: GenericNetSuiteListItem[K]): void;
}

export interface MultiLineFieldUpdateHandler {
    <K extends keyof GenericNetSuiteListItem>(key: string, value: GenericNetSuiteListItem[K]): void;
}

export interface UseGroupEditItemsParams {
    items: GenericNetSuiteListItem[];
    departments: Reference[];
    classes: Reference[];
    locations: Reference[];
    workflowId: string;
    availableFields: GroupEditItemsField[];
    availableCustomFields: domain.Field[];
    accounts?: Reference[];
    currencies?: domain.NetSuiteCurrency[];
    onRemoveLine: (id: string) => void;
    onCloneLine: (id: string) => void;
    onFieldUpdate: FieldUpdateHandler;
    onMultiLineFieldUpdate: MultiLineFieldUpdateHandler;
    updateCustomField: CustomFieldUpdateHandler;
    onItemChange?: (id: string, value: NetSuiteItem | null) => void;
    onChangeExpenseCategory?: (li: GenericNetSuiteListItem, value: NetSuiteExpenseCategory | null) => void;
    onChangeCurrency?: (li: GenericNetSuiteListItem, value: domain.NetSuiteCurrency | null) => void;
    onChangeTaxCode?: (li: GenericNetSuiteListItem, value: NetSuiteSalesTaxItem | null) => void;
}
